"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _api = require("./api");

var _trip = require("./trip");

var _departure = require("./departure");

var _nearest = require("./nearest");

var _stopPlace = require("./stopPlace");

var _bikeRental = require("./bikeRental");

var _scooters = require("./scooters");

var _geocoder = require("./geocoder");

var _config = require("./config");

function createEnturService(config) {
  return {
    journeyPlannerQuery: function journeyPlannerQuery(query, variables, config) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        console.warn('journeyPlannerQuery is deprecated and will be removed in a future release. Please use queryJourneyPlanner instead.');
      }

      return (0, _api.journeyPlannerQuery)(query, variables, config);
    },
    queryJourneyPlanner: function queryJourneyPlanner(queryObj, variables) {
      return (0, _api.journeyPlannerQuery)(queryObj, variables, (0, _config.getServiceConfig)(config));
    },
    nsrQuery: function nsrQuery(query, variables, config) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        console.warn('nsrQuery is deprecated and will be removed in a future release. Please use queryNsr instead.');
      }

      return (0, _api.nsrQuery)(query, variables, config);
    },
    queryNsr: function queryNsr(queryObj, variables) {
      return (0, _api.nsrQuery)(queryObj, variables, (0, _config.getServiceConfig)(config));
    },
    getFeatures: (0, _geocoder.createGetFeatures)(config),
    getFeaturesReverse: (0, _geocoder.createGetFeaturesReverse)(config),
    getTripPatterns: (0, _trip.createGetTripPatterns)(config),
    findTrips: (0, _trip.createFindTrips)(config),
    getStopPlaceDepartures: _departure.getStopPlaceDeparturesDEPRECATED,
    getDeparturesFromStopPlace: (0, _departure.createGetDeparturesFromStopPlace)(config),
    getDeparturesFromStopPlaces: (0, _departure.createGetDeparturesFromStopPlaces)(config),
    getDeparturesFromQuays: (0, _departure.createGetDeparturesFromQuays)(config),
    getDeparturesBetweenStopPlaces: (0, _departure.createGetDeparturesBetweenStopPlaces)(config),
    getDeparturesForServiceJourney: (0, _departure.createGetDeparturesForServiceJourney)(config),
    getNearestPlaces: (0, _nearest.createGetNearestPlaces)(config),
    getStopPlace: (0, _stopPlace.createGetStopPlace)(config),
    getStopPlaces: (0, _stopPlace.createGetStopPlaces)(config),
    getParentStopPlace: (0, _stopPlace.createGetParentStopPlace)(config),
    getStopPlacesByPosition: (0, _stopPlace.createGetStopPlacesByPosition)(config),
    getStopPlaceFacilities: (0, _stopPlace.createGetStopPlaceFacilities)(config),
    getQuaysForStopPlace: (0, _stopPlace.createGetQuaysForStopPlace)(config),
    getBikeRentalStation: (0, _bikeRental.createGetBikeRentalStation)(config),
    getBikeRentalStations: (0, _bikeRental.createGetBikeRentalStations)(config),
    getBikeRentalStationsByPosition: (0, _bikeRental.createGetBikeRentalStationsByPosition)(config),
    getScootersByPosition: (0, _scooters.createGetScootersByPosition)(config)
  };
}

var _default = createEnturService;
exports.default = _default;